<ng-container *ngIf="validations">
  <div class="field-wrapper">
    <div
      class="validation"
      *ngFor="let validation of validations; let validationIndex = index"
      [style.background]="validation.color || null"
      [class.expired]="validation.isExpired"
    >
      <div class="validator-label" [matTooltip]="validation?.label">
        {{ validation?.label }}
      </div>
    </div>
  </div>
</ng-container>
